// extracted by mini-css-extract-plugin
export default {"formError":"generalStyles_formError__-nXYL"};